<template>
	<div>
		<b-overlay :show="isLoading">
			<div class="d-flex" v-if="!isLoading">
				<AgeCard
					title="Edad Preparación"
					label="Edad (meses) mínima de los ejemplares para entrar a preparación"
					@save="(age) => saveAge(age, 'preparation')"
					:age="preparationAge"
					:min-age="1"
				/>
				<AgeCard
					title="Edad Torneos"
					label="Edad (meses) mínima para que los ejemplares puedan participar en torneos"
					@save="(age) => saveAge(age, 'tournament')"
					:age="tournamentAge"
					:min-age="1"
				/>
			</div>
		</b-overlay>
	</div>
</template>

<script>
import AgeCard from "@/views/brain/tournament/views/ages/components/AgeCard.vue"
import TournamentAgesService from "@/views/brain/tournament/views/ages/services/tournament-ages.service.js"
export default {
	name: "BrainTournamentAges",
	components: { AgeCard },
	data: () => ({
		isLoading: true,
		preparationAge: null,
		tournamentAge: null,
	}),
	computed: {},
	async mounted() {
		await this.getAges()
	},
	methods: {
		async saveAge(age, type) {
			try {
				this.isLoading = true
				await TournamentAgesService.saveAge({
					description: type,
					age,
				})
				this.showSuccessToast(
					`Edad ${(type = "preparation" ? "Preparación" : "Torneos")} guardada correctamente`
				)
				await this.getAges()
			} catch (error) {
				console.error(`Error saving ${type} age:`, error)
			} finally {
				this.isLoading = false
			}
		},
		async getAges() {
			this.isLoading = true
			try {
				const { data } = await TournamentAgesService.getAges()
				this.preparationAge = data.find((age) => age.description === "preparation").age || null
				this.tournamentAge = data.find((age) => age.description === "tournament").age || null
			} catch (error) {
				console.error("Error fetching ages:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
}
</script>
<style scoped></style>
